/* eslint-disable react/no-unescaped-entities */
import Flex from "@/components-library/layout/flex";
import classes from "./content.module.scss";

import MenuItem from "./menu-item";
import { MENU } from "@/static-texts/menu";
function Content({ selectedSubMenu, onSelectManeuItem }) {
  return (
    <Flex
      justify="space-between"
      align="center"
      direction="column"
      className={classes.container}
    >
      {MENU.map(({ title, link, subMenuOptions, id }, index) => (
        <MenuItem
          id={id}
          selectedSubMenu={selectedSubMenu}
          key={`${title}-${index}`}
          menuItemTitle={title}
          link={link}
          subMenuOptions={subMenuOptions}
          onSelectManeuItem={onSelectManeuItem}
        />
      ))}
    </Flex>
  );
}

export default Content;
